import type { VoidFunctionComponent } from 'react';

import Header from '../../../shared/settings/SettingsPageHeader';
import PageContent from '../shared/SettingsPageContent';

const ProjectReportsSettingsContainer: VoidFunctionComponent = () => (
  <PageContent>
    <Header heading="Reports" />
  </PageContent>
);

export default ProjectReportsSettingsContainer;
